import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

export default ({
  cityId,
  typeIds,
  offset,
  first,
  name,
  orderBy,
  status,
  isSelfServe,
  isSheltered,
  isEvent,
  isNeedPermit,
  times,
  onlyWithStatistics,
  conversionRate,
  scanRate,
  distributionRate,
  footTraffic,
}) => {
  const query = `query (
   $cityId: ID!
   $typeIds: [Int]
   $offset: Int
   $first: Int
   $name: String
   $orderBy: LocationOrderByEnum
   $status: LocationStatusEnum
   $isSelfServe: Boolean
   $isSheltered: Boolean
   $isEvent: Boolean
   $isNeedPermit: Boolean
   $times: [LocationTimeEnum]
   $onlyWithStatistics: Boolean
   $conversionRate: FiltersOperator
   $scanRate: FiltersOperator
   $distributionRate: FiltersOperator
   $footTraffic: FiltersOperator
  ) {
    city(id: $cityId){
      name
      id
      latitude
      longitude
      country {
        code
      }
      locations(
        offset: $offset
        first: $first
        name: $name
        orderBy: $orderBy
        status: $status
        typeIds: $typeIds
        isSelfServe: $isSelfServe
        isSheltered: $isSheltered
        isEvent: $isEvent
        isNeedPermit: $isNeedPermit
        times: $times
        onlyWithStatistics: $onlyWithStatistics
        conversionRate: $conversionRate
        scanRate: $scanRate
        distributionRate: $distributionRate
        footTraffic: $footTraffic
      ) {
        totalCount
        edges {
          node {
            id
            name
            label
            moments{
               morning
               lunch
               afternoon
            }
            isSheltered
            hasPermit
            isEvent
            status
            typeId
            type{
            name
            }
            latitude
            longitude
            statistics {
              currentConversionRate
              previousWeekConversionRate
              conversionRateDiffInPercentage
              currentScanRate
              previousWeekScanRate
              scanRateDiffInPercentage
              currentDeliveredFlyers
              previousWeekDeliveredFlyers
              deliveredFlyersDiffInPercentage
              currentFootTraffic
              previousWeekFootTraffic
              footTrafficDiffInPercentage
              deliveredFlyersNumber
            }
            schedule {
              id
              scheduleType
              eventStartDate
              eventEndDate
              eventOperationalTimes {
                start
                end
              }
              daysSchedule {
                start
                end
                day
              }
              yearlySchedule {
                start
                end
              }
              slotsScheduleDays
              morning
              lunch
              afternoon
              createdAt
              updatedAt
            }
            eventType
            description
            address
          }
        }
      }
    }
  }`
  return callAuthorizedGraphQLEndpoint(query, {
    cityId,
    typeIds,
    offset,
    first,
    name,
    orderBy,
    status,
    isSelfServe,
    isSheltered,
    isEvent,
    isNeedPermit,
    times,
    onlyWithStatistics,
    conversionRate,
    scanRate,
    distributionRate,
    footTraffic,
  })
}

export const importLocationsGQL = (locations, cityId) => {
  const query = `mutation (
    $input: ImportLocationsInput!
  ) {
    importLocations(input:$input) {
      success
      errors
    }
  }`
  return callAuthorizedGraphQLEndpoint(query, { input: { locations, cityId } })
}

export const exportLocationsGQL = cityId => {
  const query = `mutation (
    $input: ExportLocationsInput!
  ) {
    exportLocations(input:$input) {
      success
      errorMessage
      csvContent
      filename
    }
  }`
  return callAuthorizedGraphQLEndpoint(query, { input: { cityId } })
}

export const getLocationByIdGQL = (cityId, id) => {
  const query = `query (
    $cityId: ID!,
    $id: ID!
  ) {
    city(id: $cityId) {
      locations(
        locationId: $id,
        first: 1
      ) {
        edges {
          node {
            id
            name
            label
            moments{
              morning
              lunch
              afternoon
            }
            isSheltered
            hasPermit
            isEvent
            status
            typeId
            type{
              name
            }
            latitude
            longitude
            statistics {
              currentConversionRate
              previousWeekConversionRate
              conversionRateDiffInPercentage
              currentScanRate
              previousWeekScanRate
              scanRateDiffInPercentage
              currentDeliveredFlyers
              previousWeekDeliveredFlyers
              deliveredFlyersDiffInPercentage
              currentFootTraffic
              previousWeekFootTraffic
              footTrafficDiffInPercentage
              deliveredFlyersNumber
            }
            schedule {
              id
              scheduleType
              eventStartDate
              eventEndDate
              eventOperationalTimes {
                start
                end
              }
              daysSchedule {
                start
                end
                day
              }
              yearlySchedule {
                start
                end
              }
              slotsScheduleDays
              morning
              lunch
              afternoon
              createdAt
              updatedAt
            }
            eventType
            description
            address
          }
        }
      }
    }
  }`
  return callAuthorizedGraphQLEndpoint(query, { cityId, id })
}
